export const dataTypes = {
    0: 'Undefined',
    1: 'EcsInvoiceXml',
    2: 'EcsInvoicePdf',
    3: 'EcsInvoiceAttachment',
    4: 'EcsInvoiceJson',
    100: 'InternalAccountsJson',
    101: 'InternalProjectsJson',
    102: 'InternalCustomersJson',
    103: 'InternalCustomerInvoicesJson',
    104: 'InternalSuppliersJson',
    105: 'InternalSupplierInvoicesJson',
    106: 'InternalVouchersJson',
    107: 'InternalVoucherRowsJson',
    108: 'InternalCustomerInvoicePayment',
    109: 'InternalSupplierInvoicePayment',
    300: 'CompanyExpenseV3ExpenseReportJson',
    301: 'CompanyExpenseV3AddUpdateOrDeleteUserRequestJson',
    400: 'ScanCloudInvoice',
    500: 'EdiFactInvoice',
    501: 'EdiFactOrderConfirmation',
    502: 'PriSupplierInvoiceXml',
    503: 'PriSupplierOrderResponseXml',
    504: 'PriSupplierDispatchAdviceXml',
    505: 'PriSupplierInvoicePdf',
    600: 'EcsCustomerJson',
    601: 'EcsCustomersJson',
    700: 'EcsProjectJson',
    701: 'EcsProjectsJson',
    800: 'EcsSettingsJson',
    900: 'EcsSupplierJson',
    901: 'EcsSupplierInvoiceJson',
    910: 'EcsExportSupplierInvoiceAttachment',
    915: 'EcsExportSupplierInvoiceImage',
    920: 'EcsExportSuppliersJson',
    1000: 'EcsInvoicePaymentJson',
    1001: 'EcsSupplierInvoicePaymentJson',
    1100: 'EcsAttendanceTransactionsJson',
    1101: 'EcsAbsenceTransactionsJson',
    1102: 'EcsImportTimeIntervalJson',
    1200: 'EcsTaxReductionsJson',
    1300: 'EcsAccountsJson',
    1301: 'EcsAccountJson',
    1400: 'EcsCostCentersJson',
    1401: 'EcsCostCenterJson',
    1500: 'EcsItemsJson',
    1501: 'EcsExportItemJson',
    1502: 'EcsImportItemsJson',
    1503: 'EcsImportItemJson',
    1504: 'EcsImportItemPricesJson',
    1505: 'EcsImportItemPriceJson',
    1600: 'EcsTermsOfPaymentsJson',
    1601: 'EcsTermsOfPaymentJson',
    1800: 'EcsPaymentMethodJson',
    1801: 'EcsPaymentMethodsJson',
    1900: 'EcsEmployeeJson',
    1901: 'EcsEmployeesJson',

    2000: 'EcsCompanyJson',
    2100: 'EcsInvoiceBalanceJson',
    2110: 'ImportSupplierInvoiceBalanceJson',
    2200: 'EcsExportTimeCodeJson',
    2201: 'EcsExportTimeCodesJson',
    2300: 'EcsExportContactsJson',
    2400: 'EcsExportOrderJson',
    2401: 'EcsExportOrdersJson',
    2410: 'EcsExportOrderRowJson',
    2411: 'EcsExportOrderRowsJson',
    2412: 'EcsImportOrderJson',
    2413: 'EcsImportOrdersJson',
    2414: 'EcsImportOrderRowJson',
    2415: 'EcsImportOrderRowsJson',
    2416: 'EcsExportOrderParticipantsJson',
    2500: 'EcsExportObjectsJson',
    2600: 'EcsExportGeneralLedgerJson',
    2700: 'EcsExportProjectPhaseJson',
    2701: 'EcsExportProjectPhasesJson',
    2800: 'EcsExportSupplierImportRowJson',
    2801: 'EcsExportSupplierImportRowsJson',
    2802: 'EcsExportSupplierImportLogJson',
    2803: 'EcsExportSupplierImportLogsJson',
    2900: 'EcsExportEmployeeTimeJson',
    2901: 'EcsExportEmployeeTimesJson',
    2905: 'EcsExportTimeApprovalPeriodJson',
    2906: 'EcsExportTimeApprovalPeriodsJson',
    2907: 'EcsExportTimeEntryStatusJson',
    2908: 'EcsExportTimeEntryStatusesJson',
    3000: 'EcsExportVatTypes',
    10000: 'Csv',
    11000: 'Zip',
    20000: 'ExternalData',
    30000: 'Svefaktura',
    31000: 'Finvoice13',
    31001: 'Finvoice30',
    32000: 'Iizy',
    33000: 'EHF21',
    34000: 'PeppolInvoice',
    35000: 'SIE',
    36000: 'ZUGFeRD',
    36001: 'ZugFerdInvoice',
    36002: 'ZugFerdSupplierInvoice',
    37000: 'EcsImportExternalStatuses',
    38000: 'TrackedFormat',
    38001: 'TrackedExportCustomerInvoiceJson',
    38002: 'TrackedExportCustomerInvoicesJson',
    38003: 'TrackedExportCustomerInvoicePaymentJson',
    38004: 'TrackedExportCustomerInvoicePaymentsJson',
    38005: 'TrackedExportCustomerInvoiceAttachment',
    38006: 'TrackedExportCustomerInvoiceAttachments',
    38007: 'TrackedExportCustomerJson',
    38008: 'TrackedExportCustomersJson',
    38009: 'TrackedExportSupplierInvoiceJson',
    38010: 'TrackedExportSupplierInvoicesJson',
    38011: 'TrackedExportSupplierInvoicePaymentJson',
    38012: 'TrackedExportSupplierInvoicePaymentsJson',
    38013: 'TrackedExportSupplierInvoiceAttachment',
    38014: 'TrackedExportSupplierInvoiceAttachments',
    38015: 'TrackedExportSupplierJson',
    38016: 'TrackedExportSuppliersJson',
    38017: 'TrackedExportVoucherJson',
    38018: 'TrackedExportVouchersJson',
    38019: 'TrackedExportVoucherRowJson',
    38020: 'TrackedExportVoucherRowsJson',
    38021: 'TrackedExportVoucherAttachment',
    38022: 'TrackedExportVoucherAttachments',
    38023: 'TrackedExportAccountJson',
    38024: 'TrackedExportAccountsJson',
    38025: 'TrackedExportProjectJson',
    38026: 'TrackedExportProjectsJson',
    38027: 'TrackedExportActivityJson',
    38028: 'TrackedExportActivitiesJson',
    38029: 'TrackedExportCostCenterJson',
    38030: 'TrackedExportCostCentersJson',
    39000: 'EcsImportSupplierDiscountJson',
    39001: 'EcsImportSupplierDiscountsJson',
    40000: 'EcsExportPaySlipJson',
    41000: 'SymbrioEDISupplierInvoiceXML',
    42000: 'EcsImportSupplierImportLogJson',
    42001: 'EcsImportSupplierImportRowJson',
    43000: 'EcsExportSupplierInvoiceStatusJson',
    43001: 'SymbrioExportSupplierInvoiceStatusXML',
    43002: 'SymbrioExportXML',
    43003: 'SymbrioImportSupplierInvoiceImage',
    44000: 'EcsExportSalaryJson',
    44001: 'EcsExportSalariesJson',
    45000: 'Ahlsell',
    46000: 'EcsIdMapping',
    47000: 'EcsImportUsersJson',
    48000: 'XRechnungXml',
    49000: 'SepaOcr',
    49100: 'EcsRaksiReportJson',
    50000: 'IntegrationEngineAnalyticsWorkbook',
    51000: 'EntreArbitraryFileAttachment',
    52000: 'EntreArbitraryFileMetadata',
    53000: 'EcsImportBidsJson',
    53001: 'EcsImportBidRowsJson',
    54000: 'IntegrationPreviouslyHandledObject',
    55000: 'NextExportSupplierJson',
    55001: 'NextExportSuppliersJson'
};